import React, { useEffect, useState, useContext } from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { api } from '../api';
import { fetchToken, fetchRole } from '../auth/Token';
import AuthContext from "../auth/AuthProvider";
import { Box, Button, ButtonGroup, Typography,FormHelperText, Chip, Select, CircularProgress, Grid, MenuItem } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import Alert from '@mui/material/Alert';
import { DataGrid, GridToolbar, GridRowParams, GridActionsCellItem} from '@mui/x-data-grid';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { useFormik, validateYupSchema } from 'formik';
import * as Yup from 'yup';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import TransactionDetails from './TransactionDetails';
import { Send } from "@mui/icons-material";
import { Cancel } from "@mui/icons-material";
import Modal from '@mui/material/Modal';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import CancelIcon from '@mui/icons-material/Cancel';
import { toast } from 'sonner';


export const FormatedDate = ({value}) => {
  const timestamp = value;
  const date = new Date(timestamp);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours() % 12 || 12).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const amOrPm = date.getHours() >= 12 ? 'PM' : 'AM';

  const formattedDate = `${year}-${month}-${day} ${hours}:${minutes} ${amOrPm}`;
  return <span>{formattedDate}</span>;
}



export default function SavingsDetails(props) {
    const [info, setInfo] = useState([])
    const [transactionDetails, setTransactionDetails] = useState([])
    const [alert, setAlert] = useState()
    const [saveOpen, setSaveOpen] = React.useState(false);
    const [stampValue, setStampValue] = useState(null);
    const [stamp, setStamp] = useState(null);
    const [withdOpen, setWithdOpen] = useState(false);
    const [amtValue, setAmtValue] = useState(null)
    const [transferOpen, setTransferOpen] = useState(false);
    const [ transferInfo, setTransferInfo] = useState([]);
    const {  permissions } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const [decide, setDecide] = useState(stampValue? "Use Cash" : null);
    const [modalOpen, setModalOpen] = useState(false);
    const [value, setValue] = React.useState('1');
    const [value1, setValue1] = React.useState('1');
    const [value2, setValue2] = React.useState('4');
    const [start_date, setStart_date] = useState('')
    const [end_date, setEnd_date] = useState('')
    const [soc, setSoc] = useState();

    const fetch_somthing = () => {
        const storedSocOr = localStorage.getItem('soc_or');
  
    if (storedSocOr) {
      setSoc(JSON.parse(storedSocOr));
    } else {
      api
        .get("/users/user/society", {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          setSoc(response.data?.Soc);
          localStorage.setItem('soc_or', JSON.stringify(response.data?.Soc));
        })
        .catch(function (error) {
          console.log(error);
        });
    }
      }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const handleChange1 = (event, newValue) => {
        setValue1(newValue);
    };
    const handleChange2 = (event, newValue) => {
        setValue2(newValue);
    };



    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 920,
        maxHeight: '80vh', 
        overflowY: 'auto', 
        bgcolor: 'background.paper',
        border: '1px solid #e7ecef',
        borderRadius: '7px',
        boxShadow: 24,
        p: 4,
      };
      

    const handleClosee = () => {
        setModalOpen(false)
    }
    
    const handleClo = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpe(false);
      };
  
      const actio = (
        <React.Fragment>
          {/* <Button color="secondary" size="small" onClick={handleClo}>
            CLOSE
          </Button> */}
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClo}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
      );

  

        const fetchStampValue = async () => {
            await api.get(`/transactions/sform/${props.ID}`,{
                headers: {
                    Authorization: 'Bearer ' + fetchToken()
                },
            }).then(function (response) {
                setStampValue(response.data.stamp_value)
                if (response.data.stamp_value === "null"){
                    setAmtValue(null)
                }else{
                    setAmtValue(stamp * response.data.stamp_value)
                };
            }).catch(function (error){
                console.log(error)
            })
        }
          useEffect(() =>{
            fetchStampValue();
            fetch_somthing();
          },[])

    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        height: '125vh', 
        color: theme.palette.text.secondary,
      }));

      const fetchAccountDetails = () => {
        const cacheKey = `/account/save/${props.ID}`;
        const cachedData = localStorage.getItem(cacheKey);
    
        if (cachedData) {
            setInfo(JSON.parse(cachedData));
        } else {
            try {
                api.get(`/account/save/${props.ID}`, {
                    headers: {
                        Authorization: 'Bearer ' + fetchToken()
                    }
                }).then(function (response) {
                    localStorage.setItem(cacheKey, JSON.stringify(response.data));
                    setInfo(response.data);
                });
            } catch (error) {
                console.log('This is the error: ' + error);
            }
        }
    };
    

    useEffect(() => {
        fetchAccountDetails();
    },[])

      const handleClose = () => {
        props.setOpen_acc();
      };

      const [total_wit, setTotal_wit] = useState();
      const [total_dep, setTotal_dep] = useState();

      const fetchTransactions = () => {
        const cacheKey = `/transactions/member_savings_acc_id/${props.ID}?start_date=${start_date}&end_date=${end_date}`;
        const cachedData = localStorage.getItem(cacheKey);
    
        if (cachedData) {
            const data = JSON.parse(cachedData);
            setTransactionDetails(data.data);
            setTotal_wit(data.total_wit);
            setTotal_dep(data.total_dep);
        } else {
            const tj = new FormData();
            tj.append('member_savings_acc_id', props.ID);
            tj.append('start_date', start_date);
            tj.append('end_date', end_date);
    
            api.post('/transactions/transaction/member_savings_acc_id', tj, {
                headers: {
                    Authorization: 'Bearer ' + fetchToken()
                },
            }).then(function (response) {
                const responseData = response.data;
                localStorage.setItem(cacheKey, JSON.stringify(responseData));
    
                setTransactionDetails(responseData.data);
                setTotal_wit(responseData.total_wit);
                setTotal_dep(responseData.total_dep);
            }).catch(function (error) {
                console.log(error);
            });
        }
    };
    
        const savings_acc_id = props.ID
        const type = "savings"

      useEffect(() => {
        fetchTransactions();
      },[props])



      const fetchTransactions_unfil = () =>{
        setStart_date('')
        setEnd_date('')
        fetchTransactions()
      } 

    //   console.log(transactionDetails)

      const columns = [
        {
            field: "transaction_date",
            headerName: 'DateTime',
            flex: 1,
            cellClassName: "name-column--cell",
            renderCell:(params) => <FormatedDate value={params.row.transaction_date}/>
        },
        {
            field: "narration",
            headerName: "Narration",
            flex:1,
            width: 70,
            editable:true
        },
        {
            field: "debit",
            headerName: "Debit(GHS)",
            flex:1,
            width: 70,
            renderCell:(params) => (params.row.transactiontype_name === "Withdraw")? currencyFormat.format(params.row.amount) : 0,
            editable:true
        },
        {
            field: "credit",
            headerName: "Credit(GHS)",
            flex:1,
            width: 70,
            renderCell:(params) => (params.row.transactiontype_name === "Deposit")? currencyFormat.format(params.row.amount) : 0,
            editable:true
        },
        {
            field: "balance",
            headerName: "Account Balance",
            flex:1,
            width: 70,
            renderCell:(params) => currencyFormat.format(params.row.balance)
        },
        {
            field: "transaction_id",
            headerName: "Id",
            flex:1,
            width: 70,
        },
        {
            field: "transactiontype_name",
            headerName: "Type",
            flex:1,
            width: 70,
            editable:true
        },
        {
            field: "amount",
            headerName: "Amount(GH₵)",
            flex:1,
            width: 70
        },
        {
            field: "username",
            headerName: "Prepared by",
            flex:1,
            width: 70,
        },
        {
            field: "update",
            type:'action',
            headerName: "Action",
            // flex: 1,
            width:20,
            renderCell: (params) => <TransactionDetails {...{params, type,  info, savings_acc_id, fetchTransactions, fetchAccountDetails }} />
        },
        {
            field: 'delete',
            type: 'actions',
            width:20,
            getActions: (params: GridRowParams) => [
            <GridActionsCellItem
            icon={<DeleteIcon />}
            onClick={() => handleClickOpen(params.row.transaction_id)} 
            label="Open"
            />,]
        },
      ]
      const [messageid, setMessageid] = useState();
      const [openn, setOpenn] = useState(false);

      const handleClickOpen = (id) => {
        if(permissions && permissions.update_savings_transactions === true){
            setOpenn(true);
            setMessageid(id)
        }else{
            toast.error("Not Authorized")
        }
      }

      const hangcloo = () =>{
        setMessageid()
        setOpenn(true);
      }

    const handleDelete = () => {
        const id = messageid
        try {
            api.delete(`/transactions/transaction/savings/${id}`,{
                headers :{
                Authorization: 'Bearer '+ fetchToken()
                }
            }).then(function (response){
                toast.success(response.data)
                setOpenn(false)
                fetchAccountDetails();
                fetchTransactions();
            }).catch(function (error){
                console.log(error)
            })
            } 
            catch(error){
            console.log('This is that error', error )
        };
    };  

    const fetchAccount = () => {
        const data ={
            'member_id': props.member_id,
            'account_name': '',
            'type': ''
        }
        api.post('/transactions/transfer/info', data, {
            headers: {
                Authorization: 'Bearer '+fetchToken()
            },
        }).then(function (response){
            setTransferInfo(response.data);
        }).catch(function (error){
            console.log(error);
        })
     }

      useEffect(()=>{
        fetchAccount()
      },[modalOpen])


      const handleDeposit = () => { 
        setSaveOpen(true)
      };
      const handleWithdraw = () => {
        setWithdOpen(true)
      };
      const handleTransfer = () => {
        // setTransferOpen(true)
        fetchAccount()
        setModalOpen(true)
      };

      const closeTransfers = () => {
        formikkk.handleReset()
        setTransferOpen(false);
        setLoading(false)
      };

      const closeDeposit = () => {
        formik.handleReset()
        setStamp(null)
        setSaveOpen(false)
        setLoading(false)
        setDecide();
      };

      const closeWithdraw = () => {
        formik.handleReset()
        setLoading(false)
        setWithdOpen(false)
      };
    //   deposit
      const formik = useFormik({
        initialValues: {
            transaction_id:null,
            transactiontype_id: 1,
            Amount: null,
            narration: '',
            savings_acc_id: props.ID,
            balance: null,
            decide: decide,
        },
        validationSchema: Yup.object({
            Amount: Yup.number()
                .required('Specify Amount To deposit').min(0),
            narration: Yup.string()
        }),
        onSubmit: (values) => {
            setLoading(true)
            // console.log(values)
            api.post('/transactions/transaction/savings', values , {
                headers: {
                    Authorization:'Bearer ' + fetchToken(),
                },
            }).then(function (response) {
                toast.success(response.data)
                formik.handleReset()
                closeDeposit()
                setDecide();
            }).catch(function (error){
                // setAlert(<Alert severity="error">{error.response.data.detail}</Alert>)
                console.log(error)
            }).finally(function (){
                setLoading(false)
                setAlert()
                fetchTransactions()
                fetchAccountDetails() 
                props.fetchAccounts()
            })
        }
      })
    //   withdraw

    const formikk = useFormik({
        initialValues: {
            transactiontype_idd: 2,
            Amountt: null,
            narrationn: '',
            savings_acc_idd: props.ID
        },
        validationSchema: Yup.object({
            Amountt: Yup.number()
                .required('Specify Amount To Withdraw').min(0).max(info[0]?.current_balance),
            narrationn: Yup.string()
        }),
        onSubmit: (values) => {
            // console.log(values)
            setLoading(true)
            api.post('/transactions/transaction/withdraw', values , {
                headers: {
                    Authorization:'Bearer ' + fetchToken(),
                },
            }).then(function (response) {
                toast.success(response.data)
                formikk.handleReset()
                setAlert()
                closeWithdraw()
                fetchAccountDetails();
                fetchTransactions();
            }).catch(function (error){
                setAlert(<Alert severity="error">Transaction Failed</Alert>)
                console.log(error)
            }).finally(function (){
                setLoading(false)
                props.fetchAccounts()
            })
        }
      })

    
    const [open, setOpen] = useState(false);

    const handleDeleteAcc = () =>{
        api.delete(`account/delete_acc/save/${props.ID}`, {
            headers: {
                Authorization: 'Bearer '+fetchToken()
            },
        }).then(function (response){
            setOpen(false);
            toast.success(response.data);
            if(response.data === "Account Deleted"){
                props.fetchAccounts();
                handleClose();  
                toast.error(response.data) 
            }
        }).catch(function (error){
            console.log(error);
        })
    }
    
    const [savingsDetails, setSavingsDetails] = useState([]);
    const fetchSavingsAccounts = (id) => {
        api.get(`/transactions/savings/share/${id}`, {
            headers: {
                Authorization: 'Bearer '+ fetchToken()
            },
        }).then(function (response) {
          setSavingsDetails(response.data?.Accounts);
        }).catch(function (error) {
            console.log(error)
        })
    }

    const [shareValue, setShareValue] = useState(null);
    const [enterAmt, setEnterAmt] = useState(null);
    const [typeAr, setTypeAr] = useState("");
    const openUpForm = (id, name) => {
        setEnterAmt(id)
        setTypeAr(name)
        if (name === "shares"){
            fetchSavingsAccounts(id)
            api.get(`/transactions/shform/${id}`,{
                    headers: {
                        Authorization: 'Bearer ' + fetchToken()
                    },
                }).then(function (response) {
                    setShareValue(response.data.share_value);
                }).catch(function (error){
                    console.log(error)
                })
        }
    }

    
    // transfer
    const formikkk = useFormik({
        initialValues: {
            to_accountType: '',
            Amount: null,
            savings_acc_id: props.ID,
            to_member_account_id: null,
            period: null,
            on_due_date: '',
            spending_means: '',
            account_name: '',
        },
        validationSchema: Yup.object({
            Amount: Yup.number()
                .required('Specify Amount To transfer').min(0)
                .max(info[0]?.current_balance),
            on_due_date: Yup.string('Field is required'),
            spending_means: Yup.string('Field is required'),
        }),
        onSubmit: (values) => {
            setLoading(true)
            api.post('/transactions/transfer', values , {
                headers: {
                    Authorization:'Bearer ' + fetchToken(),
                },
            }).then(function (response) {
                formikkk.handleReset();
                setModalOpen(false)
                toast.success(response.data);
                // handleClosee();
                handleModalCloseNow()
            }).catch(function (error){
                console.log(error)
            })
        }
      })

    //   const handle = () => {
    //     console.log(formikkk.errors)
    //   }

    const handleSetThings = () => {
        formikkk.setFieldValue('to_member_account_id', enterAmt);
        formikkk.setFieldValue('to_accountType', typeAr);
    };

    useEffect(() => {
        handleSetThings()
    },[enterAmt, typeAr])

    // console.log(formikkk.values)

    const [society, setSociety] = useState([])
    const fetchhmm = () =>{
        api.get('/association/societies/diff',{
          headers: {
            Authorization: 'Bearer '+fetchToken()
          }
        }).then(function (response){
            setSociety(response.data?.Society)
        }).catch(function (error){
          console.log(error)
        })
      }
      useEffect(()=>{
        fetchhmm();
      },[])

      const [AssoKinds, setAssoKinds] = useState([]);

      const getKinds = (id) => {
        api.get(`/association/types/${id}`, {
            headers :{
              Authorization: 'Bearer '+ fetchToken()
            }
          }).then(function (response) {
            setAssoKinds(response.data?.types);
          }).catch(function (error){
            console.log(error.response);
          });
      }
      
      const [associations_all, setAssociations_All] = useState([]);
      const handleAssocia = (id) => {
            api.get(`/association/type/${id}`,{
                headers: {
                    Authorization: 'Bearer '+ fetchToken()
                }
            }).then(function (response) {
                setAssociations_All(response.data)
            }).catch(function (error){
                console.log(error)
            })
       }
 

    const [passbook_all, setPassbook_All] = useState([]);

    const handlePassBook = (id) => {
        api.get(`/members/passbooks/transfer/${id}`,{
            headers: {
                Authorization: 'Bearer '+ fetchToken()
            }
        }).then(function (response) {
            setPassbook_All(response.data)
        }).catch(function (error){
            console.log(error)
        })
    }

    const [savingsAcc, setSavingsAcc] = useState([]);
    const [loansAcc, setLoansAcc] = useState([]);
    const [sharesAcc, setSharesAcc] = useState([]);
    const [owner_name, setOwner_name] = useState("");

    const fetchAccounts = (id, name) => {
        const cacheKey = `/account/accounts/${id}`;
      
        const cachedData = localStorage.getItem(cacheKey);
      
        if (cachedData) {
          const data = JSON.parse(cachedData);
          setSavingsAcc(data?.Savings_acc);
          setLoansAcc(data?.Loans_acc);
          setSharesAcc(data?.Shares_acc);
          setOwner_name(name);
        } else {
          api.get(`/account/accounts/${id}`, {
            headers: {
              Authorization: 'Bearer ' + fetchToken()
            }
          })
          .then(function (response) {
            const dataToCache = {
              Savings_acc: response.data?.Savings_acc,
              Loans_acc: response.data?.Loans_acc,
              Shares_acc: response.data?.Shares_acc
            };
            localStorage.setItem(cacheKey, JSON.stringify(dataToCache));
      
            setSavingsAcc(response.data?.Savings_acc);
            setLoansAcc(response.data?.Loans_acc);
            setSharesAcc(response.data?.Shares_acc);
            setOwner_name(name);
          })
          .catch(function (error) {
            console.log(error);
          });
        }
      };
      

  


    const handleModalCloseNow = () => {
        setModalOpen(false);
        setLoading(false);
        setAlert();
        fetchTransactions();
        fetchAccountDetails() ;
        props.fetchAccounts();
        setEnterAmt();
        setTypeAr();
        setAssoKinds([])
        setAssociations_All([])
        setPassbook_All([])
        setSavingsAcc([])
        setLoansAcc([])
        setSharesAcc([])
        setOwner_name("")
        setValue('1')
        setValue1('1')
        setValue2('4')
    }

    const CustomFooterRow = () => {
        return (
          <div>
            <div style={{ display: 'flex', padding: '4px' }}>
              <Typography variant="h5" sx={{ color:'red', mr:4 }}>Total:</Typography>
              <Typography variant="h5" sx={{ color:'darkblue', mr:4 }}>Debit: {total_wit} </Typography>
              <Typography variant="h5" sx={{ color:'darkblue', mr:4 }}>Credit: {total_dep} </Typography>
             </div>
          </div>
        );
      };

      const currencyFormat = new Intl.NumberFormat('en-GH', {
        style: 'currency',
        currency: 'GHS',
      });

    //   console.log(society)
if(transactionDetails){
    return (
        <div>
            <Item>
            {alert}
                <Box
                    sx={{
                         display:'flex',
                         justifyContent:'space-between'
                        }}
                ><Button onClick={handleClose} variant='contained' color='warning'>Close</Button>
                    <Typography>Current Balance: <span style={{ fontWeight:'700' }}>{currencyFormat.format(info[0]?.current_balance)}</span></Typography>
                    <Typography variant='h4' sx={{ fontWeight: '700',color:'darkblue' }}>{props.name}</Typography>
                    <Typography>Open date: {info[0]?.open_date}</Typography>
                </Box>
                
                
                <Box
                    sx={{ 
                        display:'flex-end'
                     }}
                >
                    {
                        permissions && permissions.create_savings_transactions === true ?
                        <ButtonGroup variant="contained" aria-label="outlined primary button group">
                            <Button onClick={handleDeposit}>Deposit</Button>
                            <Button onClick={handleWithdraw} disabled={info[0]?.current_balance > 0 ? false :true} >Withdraw</Button>
                            <Button onClick={handleTransfer} disabled={info[0]?.current_balance > 0 ? false :true}>Transfer</Button>
                        </ButtonGroup>
                        :
                        null
                    }
                    
                    
                </Box>
                <Box
                    m="40px 0 0 0"
                    height="85vh"
                    paddingBottom="55px"
                >
                    {
                        permissions && permissions.update_savings_transactions === true?
                        <>
                        <Typography variant='h3' sx={{ marginBottom:'10px' }}>Current Transactions</Typography>
                        <>
                <Typography>Filter Date</Typography>
                <div style={{ display:'flex' }}>
                <TextField
                    type='date'
                    size="small"
                    required 
                    variant="outlined"
                    helperText="From"
                    name="start_date"
                    onChange={(e) => setStart_date(e.target.value)}
                    value={start_date}
                    sx={{ mr:1 }}
                />

                <TextField
                    type='date'
                    size="small"
                    required
                    variant="outlined"
                    helperText="To"
                    name="end_date"
                    onChange={(e) => setEnd_date(e.target.value)}
                    value={end_date}
                    sx={{ mr:1 }}
                />

                <IconButton sx={{ mb:2 }} onClick={fetchTransactions}><FilterAltOutlinedIcon /></IconButton>
                <IconButton sx={{ mb:2 }} onClick={fetchTransactions_unfil}><CancelIcon /></IconButton>
                </div>
                </>
                        <DataGrid
                            rows={transactionDetails}
                            columns={columns}
                            checkboxSelection
                            getRowId={(row) => row.transaction_id}
                            slots={{ toolbar: GridToolbar, footer: CustomFooterRow }}
                            initialState={{
                                columns: {
                                  columnVisibilityModel: {
                                    transaction_id: false,
                                    amount:false,
                                    username:false,
                                    transactiontype_name:false
                                  },
                                },
                              }}
                        />
                        </>
                        : null
                    }
                        <Button
                            sx={{ m:2 }}
                            onClick={()=>setOpen(true)}
                            variant='contained'
                            color='warning'
                        >
                            Delete Account
                        </Button>
                </Box>
                <Dialog
                    open={open}
                    onClose={() =>setOpen(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                    {"Delete Account"}
                    </DialogTitle>
                    <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        This action cannot be undone. NB: this will also delete all
                        transactions in this account.
                        Do you wish to continue?
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleDeleteAcc} autoFocus>
                        Continue
                    </Button>
                    </DialogActions>
                </Dialog>
    
            </Item>
            <Dialog open={saveOpen} onClose={closeDeposit}>
                <form onSubmit={formik.handleSubmit}>
                <DialogTitle>Transaction</DialogTitle>
                <DialogContent>
                <DialogContentText>
                    Deposit
                </DialogContentText>
                
                {
                    stampValue?
                        <>
                    <div sx={{ display:'flex' }}>
                        <Button variant='outlined' sx={{ mr:2 }} size='small' color='success' onClick={(decide) => formik.setFieldValue('decide', "Use Stamps")}>Use Stamps</Button>                       
                        <Button variant='outlined' size='small' color='success' onClick={(decide) => formik.setFieldValue('decide', "Use Cash")}>Use Cash</Button>
                    </div>
                        {
                                formik.values.decide === "Use Stamps"?
                            <>
                            <p>1 Stamp = {currencyFormat.format(stampValue)}</p>
                            <TextField
                                margin="dense"
                                id="Amount"
                                name="Amount"
                                label="Stamp Value"
                                onChange={formik.handleChange}
                                value={formik.values.Amount}
                                onBlur={formik.handleBlur}
                                error={formik.touched.Amount && Boolean(formik.errors.Amount)}
                                helperText={formik.touched.Amount && formik.errors.Amount}
                                type="number"
                                fullWidth
                                variant="outlined"
                            />
                            
                            Stamp Value :
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{currencyFormat.format(formik.values.Amount * stampValue)}</b></Typography>
                            </>
                            : formik.values.decide === "Use Cash" ?
                            <TextField
                            margin="dense"
                            id="Amount"
                            name="Amount"
                            label="Amount"
                            onChange={formik.handleChange}
                            value={formik.values.Amount}
                            onBlur={formik.handleBlur}
                            error={formik.touched.Amount && Boolean(formik.errors.Amount)}
                            helperText={formik.touched.Amount && formik.errors.Amount}
                            type="number"
                            fullWidth
                            variant="outlined"
                        />
                        : null
                        }
                        </>
                    : formik.values.decide === "Use Cash" ?
                    <TextField
                        margin="dense"
                        id="Amount"
                        name="Amount"
                        label="Amount"
                        onChange={formik.handleChange}
                        value={formik.values.Amount}
                        onBlur={formik.handleBlur}
                        error={formik.touched.Amount && Boolean(formik.errors.Amount)}
                        helperText={formik.touched.Amount && formik.errors.Amount}
                        type="number"
                        fullWidth
                        variant="outlined"
                    />
                    : 
                    <TextField
                        margin="dense"
                        id="Amount"
                        name="Amount"
                        label="Amount"
                        onChange={formik.handleChange}
                        value={formik.values.Amount}
                        onBlur={formik.handleBlur}
                        error={formik.touched.Amount && Boolean(formik.errors.Amount)}
                        helperText={formik.touched.Amount && formik.errors.Amount}
                        type="number"
                        fullWidth
                        variant="outlined"
                />
                }
                    
                <TextField
                    margin="dense"
                    id="narration"
                    name="narration"
                    label="Narration (optional)"
                    onChange={formik.handleChange}
                    type="text"
                    value={formik.values.narration}
                    onBlur={formik.handleBlur}
                    error={formik.touched.narration && Boolean(formik.errors.narration)}
                    helperText={formik.touched.narration && formik.errors.narration}
                    fullWidth
                    variant="outlined"
                />
                
                </DialogContent>
                <DialogActions>
                <Button size='small' variant='contained' sx={{ backgroundColor:"#78290f", color: '#fff' }} onClick={closeDeposit}>Cancel</Button>
                <Button
                 type='submit'
                 size='small'
                 variant='contained'
                 sx={{ backgroundColor:"#80ffdb", color: '#000' }}
                >
                    { loading === true ? 
                     <Box sx={{ width: '100%' }}>
                        <CircularProgress />
                    </Box>
                    :
                    "Deposit"
                    }
                </Button>
                </DialogActions>
                </form>
            </Dialog>
    
                {/* withdraw */}
            <Dialog open={withdOpen} onClose={closeWithdraw}>
                <form onSubmit={formikk.handleSubmit}>
                <DialogTitle>Transaction</DialogTitle>
                <DialogContent>
                <DialogContentText>
                    Withdraw
                </DialogContentText>
                    <TextField
                        margin="dense"
                        id="Amountt"
                        name="Amountt"
                        label="Amount to withdraw"
                        onChange={formikk.handleChange}
                        value={formikk.values.Amountt}
                        onBlur={formikk.handleBlur}
                        error={formikk.touched.Amountt && Boolean(formikk.errors.Amountt)}
                        helperText={formikk.touched.Amountt && formikk.errors.Amountt}
                        type="number"
                        fullWidth
                        variant="outlined"
                    />
                    
    
                <TextField
                    margin="dense"
                    id="narrationn"
                    name="narrationn"
                    label="Narration (optional)"
                    onChange={formikk.handleChange}
                    type="text"
                    value={formikk.values.narrationn}
                    onBlur={formikk.handleBlur}
                    error={formikk.touched.narrationn && Boolean(formikk.errors.narrationn)}
                    helperText={formikk.touched.narrationn && formikk.errors.narrationn}
                    fullWidth
                    variant="outlined"
                />
                
                </DialogContent>
                <DialogActions>
                <Button onClick={closeWithdraw}>Cancel</Button>
                <Button
                 type='submit'
                >
                    { loading === true ? 
                     <Box sx={{ width: '100%' }}>
                        <CircularProgress  size='15'/>
                    </Box>
                    :
                    "Withdraw"
                    }
                </Button>
                </DialogActions>
                </form>
            </Dialog>
    
                    {/* Transfer */}
                <Modal
                    open={modalOpen}
                    onClose={handleClosee}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                 <Box sx={style}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <Typography variant='h4' color='#023047' > Transfer  </Typography>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Box sx={{ width: '100%', typography: 'body1' }}>
                            <TabContext value={value1}>
                                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                        <TabList onChange={handleChange1} aria-label="lab API tabs example">
                                            <Tab label="My accounts" value="1" />
                                            <Tab label="Other Accounts" value="2" />
                                        </TabList>
                                    </Box>

                                    <TabPanel value="1">
                                        <TabContext value={value}>
                                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                            <TabList onChange={handleChange} aria-label="lab API tabs example">
                                                <Tab label="Savings Account" value="1" />
                                                <Tab label="Pay off Loans" value="2" />
                                                <Tab label="Buy Shares" value="3" />
                                            </TabList>
                                        </Box>
                                    <TabPanel value="1">
                                        {
                                            transferInfo.My_Savings_Acc?
                                            <>
                                                <Autocomplete
                                                    disablePortal
                                                    id="combo-box-demo"
                                                    options={transferInfo.My_Savings_Acc}
                                                    sx={{ width: 300 }}
                                                    getOptionLabel={(option) => `${option.account_name} (${option.association_name})`}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    onChange={(event, value) => {
                                                        if (value) {
                                                            openUpForm(value.id, "savings");
                                                        }
                                                    }}
                                                    renderInput={(params) => <TextField {...params} label="Select Savings Account" />}
                                                />
                                        </>
                                            :<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <CircularProgress />
                                            </Box>
                                        }
                                        
                                    </TabPanel>
                                    <TabPanel value="2">
                                        {
                                            transferInfo.My_Loans_Acc?
                                            <>
                                            <Autocomplete
                                                    disablePortal
                                                    id="combo-box-demo"
                                                    options={transferInfo.My_Loans_Acc}
                                                    sx={{ width: 300 }}
                                                    getOptionLabel={(option) => `${option.account_name} (${option.association_name})`}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id} // Assuming 'id' is a unique identifier
                                                    onChange={(event, value) => {
                                                        if (value) {
                                                            openUpForm(value.id, "loans");
                                                        }
                                                    }}
                                                    renderInput={(params) => <TextField {...params} label="Select Loan Account" />}
                                                />
                                            </>
                                            :<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <CircularProgress />
                                            </Box>
                                        }
                                    </TabPanel>
                                    <TabPanel value="3">
                                        {
                                            transferInfo.My_Shares_Acc?
                                            <>
                                            <Autocomplete
                                                    disablePortal
                                                    id="combo-box-demo"
                                                    options={transferInfo.My_Shares_Acc}
                                                    sx={{ width: 300 }}
                                                    getOptionLabel={(option) => `${option.account_name} (${option.association_name})`}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id} 
                                                    onChange={(event, value) => {
                                                        if (value) {
                                                            openUpForm(value.id, "shares");
                                                        }
                                                    }}
                                                    renderInput={(params) => <TextField {...params} label="Select Share Account" />}
                                                />
                                            </>
                                            :<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <CircularProgress />
                                            </Box>
                                        }
                                    </TabPanel>
                                </TabContext>
                       <Grid item xs={12} md={6}>
                        {
                            enterAmt && typeAr === "savings"
                            ?
                            <Box sx={{ mt:2 }}>
                                <form onSubmit={formikkk.handleSubmit}>
                                <TextField
                                    margin="dense"
                                    id="Amount"
                                    name="Amount"
                                    label="Amount to Transfer"
                                    onChange={(e) => formikkk.setFieldValue("Amount", e.target.value)}
                                    value={formikkk.values.Amount}
                                    onBlur={formikkk.handleBlur}
                                    error={formikkk.touched.Amount && Boolean(formikkk.errors.Amount)}
                                    helperText={formikkk.touched.Amount && formikkk.errors.Amount}
                                    type="number"
                                    fullWidth
                                    variant="outlined"
                                />
                                <Button
                                    size='small'
                                    onClick={() => setEnterAmt()}
                                    color='error'
                                    variant='contained'
                                    sx={{ mt:1, mr:1 }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant='contained'
                                    type='submit'
                                    color='success'
                                    size='small'
                                    sx={{ mt:1 }}
                                >
                                    {
                                        loading === true ?
                                        <Box sx={{ width: '100%' }}>
                                            <CircularProgress />
                                        </Box>
                                        : "Transfer"
                                    }
                                </Button>
                                </form>
                            </Box>
                            : enterAmt && typeAr === "loans" ?
                            <Box sx={{ mt:2 }}>
                                <form onSubmit={formikkk.handleSubmit}>
                                <TextField
                                    margin="dense"
                                    id="Amount"
                                    name="Amount"
                                    label="Amount to Transfer"
                                    onChange={(e) => formikkk.setFieldValue("Amount", e.target.value)}
                                    value={formikkk.values.Amount}
                                    onBlur={formikkk.handleBlur}
                                    error={formikkk.touched.Amount && Boolean(formikkk.errors.Amount)}
                                    helperText={formikkk.touched.Amount && formikkk.errors.Amount}
                                    type="number"
                                    fullWidth
                                    variant="outlined"
                                />
                                <Button
                                    size='small'
                                    onClick={() => setEnterAmt()}
                                    color='error'
                                    variant='contained'
                                    sx={{ mt:1, mr:1 }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant='contained'
                                    type='submit'
                                    color='success'
                                    size='small'
                                    sx={{ mt:1 }}
                                >
                                    {
                                        loading === true ?
                                        <Box sx={{ width: '100%' }}>
                                            <CircularProgress />
                                        </Box>
                                        : "Transfer"
                                    }
                                </Button>
                                </form>
                            </Box>
                            : enterAmt && typeAr === "shares" ?
                            <Box sx={{ mt:2 }}>
                                <form onSubmit={formikkk.handleSubmit}>
                                <p>1 Share = GH₵{shareValue}.00</p>
                                <TextField
                                    margin="dense"
                                    id="Amount"
                                    name="Amount"
                                    label="Amount to Transfer"
                                    onChange={(e) => formikkk.setFieldValue("Amount", e.target.value)}
                                    value={formikkk.values.Amount}
                                    onBlur={formikkk.handleBlur}
                                    error={formikkk.touched.Amount && Boolean(formikkk.errors.Amount)}
                                    helperText={formikkk.touched.Amount && formikkk.errors.Amount}
                                    type="number"
                                    fullWidth
                                    size='small'
                                    variant="outlined"
                                />

                                Share Value:
                                <Typography sx={{ fontWeight: '700' }}>GH₵{formikkk.values.Amount * shareValue}.00</Typography>

                                <FormHelperText>Set period</FormHelperText>
                            <Select
                                margin="dense"
                                disabled={(formikkk.values.period)? true :false}
                                id="period"
                                required
                                name="period"
                                onChange={formikkk.handleChange}
                                type="date"
                                value={formikkk.values.period}
                                helperText="Set Period"
                                fullWidth
                                size='small'
                                variant="outlined"
                                sx={{ marginBottom:1 }}
                            >
                                <MenuItem value={null}>Or Set number of Years</MenuItem>
                                <MenuItem value={0.25}>3 months</MenuItem>
                                <MenuItem value={0.5}>6 months</MenuItem>
                                <MenuItem value={1}>1 year</MenuItem>
                            </Select>
                            <Typography>OR</Typography>
                            <FormHelperText>Set Number of years</FormHelperText>
                            <TextField
                                margin="dense"
                                disabled={(formikkk.values.period)? true :false}
                                id="period"
                                required
                                name="period"
                                onChange={formikkk.handleChange}
                                type="number"
                                value={formikkk.values.period}
                                onBlur={formikkk.handleBlur}
                                error={formikkk.touched.period && Boolean(formikkk.errors.period)}
                                helperText={formikkk.touched.period && formikkk.errors.period}
                                // helperText="Set Number of years"
                                fullWidth
                                size='small'
                                variant="outlined"
                                sx={{ marginBottom:5 }}
                            />
                            <FormHelperText>What occurs on the date when the share ends?</FormHelperText>
                            <Select
                                required
                                margin="dense"
                                id="on_due_date"
                                name="on_due_date"
                                label="Action to be taken on due date"
                                onChange={formikkk.handleChange}
                                value={formikkk.values.on_due_date}
                                onBlur={formikkk.handleBlur}
                                error={formikkk.touched.on_due_date && Boolean(formikkk.errors.on_due_date)}
                                helperText={formikkk.touched.on_due_date && formikkk.errors.on_due_date}
                                fullWidth
                                size='small'
                                sx={{ marginBottom:1 }}
                                variant="outlined"
                            >
                                <MenuItem value="rolled over with interest">Roll Over With Interest</MenuItem>
                                <MenuItem value="rolled over without interest">Roll Over Without Interest</MenuItem>
                                <MenuItem value="canceled">End</MenuItem>
                            </Select>
                            

                            <Select
                                // margin="dense"
                                disabled={(formikkk.values.on_due_date === "rolled over with interest")? true :false}
                                id="spending_means"
                                name="spending_means"
                                label="Action to be taken on after end date"
                                onChange={formikkk.handleChange}
                                value={formikkk.values.spending_means}
                                onBlur={formikkk.handleBlur}
                                error={formikkk.touched.spending_means && Boolean(formikkk.errors.spending_means)}
                                helperText={formikkk.touched.spending_means && formikkk.errors.spending_means}
                                fullWidth
                                size='small'
                                variant="outlined"
                            >
                                <MenuItem value="transferred to your ">Transfer to Savings Account</MenuItem>
                                <MenuItem value="withdrawn">Withdraw</MenuItem>
                            </Select>


                            <Select
                                // margin="dense"
                                disabled={(formikkk.values.spending_means === "transferred to your ")? false:true }
                                id="account_name"
                                name="account_name"
                                label="Set Savings Account"
                                onChange={formikkk.handleChange}
                                value={formikkk.values.account_name}
                                helperText="Set Account"
                                fullWidth
                                sx={{ marginTop:1 }}
                                variant="outlined"
                            >
                            {savingsDetails.map((item) => (
                                <MenuItem key={item.id} value={item.account_name}>{item.account_name}</MenuItem>
                            ))} 
                            </Select>

                                <Button
                                    // size='small'
                                    onClick={() => setEnterAmt()}
                                    color='error'
                                    variant='contained'
                                    sx={{ mt:1, mr:1 }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant='contained'
                                    type='submit'
                                    color='success'
                                    // size='small'
                                    sx={{ mt:1 }}
                                >
                                    {
                                        loading === true ?
                                        <Box sx={{ width: '100%' }}>
                                            <CircularProgress />
                                        </Box>
                                        : "Transfer"
                                    }
                                </Button>
                                </form>
                            </Box>
                            :
                            <>
                                <Typography
                                    variant='h5'
                                    sx={{color:'#023047', mt:2}}
                                >
                                    Click on an account to start transfer 
                                </Typography>
                            </>
                        }
                        
                        </Grid>
                 </TabPanel>
                                    
                <TabPanel value="2">
                <Grid item xs={12} md={12}>
                    <Box sx={{ width: '100%', typography: 'body1' }}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={6}>
                                <Typography variant='h5'> Select Society</Typography>

                                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                    {
                                        soc === 0?
                                        society.map((item) =>
                                        (
                                            <Chip key={item.id} onClick={() => getKinds(item.id)} label={`${item.society}`} style={{ margin: '4px'}} sx={{ backgroundColor:"#c1121f", color: '#f5ebe0' }} />
                                        ))
                                        :
                                        <Chip key={society.id} onClick={() => getKinds(society.id)} label={`${society.society}`} style={{ margin: '4px'}} sx={{ backgroundColor:"#c1121f", color: '#f5ebe0' }} />

                                    }
                                </div>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                {   
                                    AssoKinds[0] ?
                                    (
                                        <>
                                        <Typography variant='h5'>Select Savings Group Kind</Typography>
                                            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                {AssoKinds.map((assoKind) => (
                                                    <Chip
                                                        key={assoKind.associationtype_id}
                                                        label={`${assoKind.association_type}`}
                                                        style={{ margin: '4px' }}
                                                        sx={{ backgroundColor: "#fdf0d5", color: '#000814' }}
                                                        onClick={() => handleAssocia(assoKind.associationtype_id)}
                                                    />
                                                ))}
                                            </div>
                                            <Button
                                                onClick={() => setAssoKinds([])}
                                                variant='contained'
                                                sx={{ backgroundColor: '#9a031e', color: '#f2e8cf', borderRadius:2, mt:2 }}
                                                size='small'
                                                disabled={associations_all[1]? true: false}
                                            >
                                                Close
                                            </Button>
                                        </>
                                    )
                                    : null
                                }
                            </Grid>
                            <Grid item xs={12} md={6} sx={{ mt:2 }}>
                                {
                                    associations_all[1] ?
                                    <>
                                        <Autocomplete
                                            id="combo-box-associations"
                                            options={associations_all[1]}
                                            getOptionLabel={(option) => option.association_name}
                                            sx={{ width: 300, mb: 2 }}
                                            renderInput={(params) => <TextField {...params} label="Filter Savings Groups" />}
                                            onChange={(event, value) => {
                                                if (value) {
                                                    handlePassBook(value.association_id);
                                                }
                                            }}
                                            renderOption={(props, option) => (
                                                <li {...props} key={option.association_id}>
                                                    {option.association_name}
                                                </li>
                                            )}
                                        />


                                    <Button
                                        onClick={() => setAssociations_All([])}
                                        variant='contained'
                                        sx={{ backgroundColor: '#9a031e', color: '#f2e8cf', borderRadius:2, mt:2 }}
                                        size='small'
                                        disabled={passbook_all[0]? true: false}
                                    >
                                        Close
                                    </Button>
                                    </>
                                    : null
                                }
                            </Grid>

                            <Grid item xs={12} md={6} sx={{ mt:2 }}>
                                {
                                    passbook_all[0] ?
                                    <>
                                    <Typography variant='h5'>Select Passbook</Typography>
                                    <Autocomplete
                                        id="combo-box-passbook"
                                        options={passbook_all}
                                        getOptionLabel={(option) => `${option.firstname} ${option.lastname} (${option.passbook_id})`}
                                        sx={{ width: 300, mb: 2 }}
                                        renderInput={(params) => <TextField {...params} label="Select Member" />}
                                        onChange={(event, value) => {
                                            if (value) {
                                                fetchAccounts(value.association_members_id, `${value.firstname} ${value.lastname}`);
                                            }
                                        }}
                                        renderOption={(props, option) => (
                                            <li {...props} key={option.association_members_id}>
                                                {`${option.firstname} ${option.lastname} (${option.passbook_id})`}
                                            </li>
                                        )}
                                    />

                                    <Button
                                        onClick={() => setPassbook_All([])}
                                        variant='contained'
                                        sx={{ backgroundColor: '#9a031e', color: '#f2e8cf', borderRadius:2, mt:2 }}
                                        size='small'
                                    >
                                        Close
                                    </Button>
                                    </>
                                    : null
                                }
                            </Grid>

                            <Grid item xs={12} md={12}>
                                {
                                    savingsAcc[0] || loansAcc[0] || sharesAcc[0]? 
                                    <>
                                    <Typography variant='h6' color='#023047' > Transfer to {owner_name}  </Typography>
                                        <TabContext value={value2}>
                                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                                <TabList onChange={handleChange2} aria-label="lab API tabs example">
                                                    <Tab label="Chose Tab" value="4" />
                                                    <Tab label="Savings Account" value="1" />
                                                    <Tab label="Pay off Loan" value="2" />
                                                    <Tab label="Buy Share" value="3" />
                                                </TabList>
                                            </Box>
                                                <TabPanel value='4'>

                                                </TabPanel>
                                            <TabPanel value='1'>
                                                {
                                                    savingsAcc[0]?
                                                    <>
                                                        <Autocomplete
                                                            id="combo-box-savings"
                                                            options={savingsAcc}
                                                            getOptionLabel={(option) => option.Account_Name}
                                                            sx={{ width: 300, mb: 2 }}
                                                            renderInput={(params) => <TextField {...params} label="Select Savings Account" />}
                                                            onChange={(event, value) => {
                                                                if (value) {
                                                                    openUpForm(value.ID, "savings");
                                                                }
                                                            }}
                                                            renderOption={(props, option) => (
                                                                <li {...props} key={option.ID}>
                                                                    {option.Account_Name}
                                                                </li>
                                                            )}
                                                        />

                                                    </>
                                                    :<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                        <CircularProgress />
                                                    </Box>
                                                }
                                            </TabPanel>

                                            <TabPanel value='2'>
                                            {
                                                    loansAcc[0]?
                                                    <Autocomplete
                                                        id="combo-box-savings"
                                                        options={loansAcc}
                                                        getOptionLabel={(option) => option.account_name}
                                                        sx={{ width: 300, mb: 2 }}
                                                        renderInput={(params) => <TextField {...params} label="Select Loan Account" />}
                                                        onChange={(event, value) => {
                                                            if (value) {
                                                                openUpForm(value.ID, "loans");
                                                            }
                                                        }}
                                                        renderOption={(props, option) => (
                                                            <li {...props} key={option.ID}>
                                                                {option.account_name}
                                                            </li>
                                                        )}
                                                    />
                                                
                                                    :<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                        <CircularProgress />
                                                    </Box>
                                                }
                                            </TabPanel>

                                            <TabPanel value='3'>
                                            {
                                                    sharesAcc[0]?
                                                    <Autocomplete
                                                        id="combo-box-savings"
                                                        options={sharesAcc}
                                                        getOptionLabel={(option) => option.account_name}
                                                        sx={{ width: 300, mb: 2 }}
                                                        renderInput={(params) => <TextField {...params} label="Select Share Account" />}
                                                        onChange={(event, value) => {
                                                            if (value) {
                                                                openUpForm(value.ID, "shares");
                                                            }
                                                        }}
                                                        renderOption={(props, option) => (
                                                            <li {...props} key={option.ID}>
                                                                {option.account_name}
                                                            </li>
                                                        )}
                                                    />
                                                    :<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                        <CircularProgress />
                                                    </Box>
                                                }
                                            </TabPanel>
                                        </TabContext>
                                    </>
                                    :
                                    null
                                }
                            </Grid>
                            <Grid item xs={12} md={12}>
                        {
                            enterAmt && typeAr === "savings"
                            ?
                            <Box sx={{ mt:1 }}>
                                <form onSubmit={formikkk.handleSubmit}>
                                <TextField
                                    margin="dense"
                                    id="Amount"
                                    name="Amount"
                                    label="Amount to Transfer"
                                    onChange={(e) => formikkk.setFieldValue("Amount", e.target.value)}
                                    value={formikkk.values.Amount}
                                    onBlur={formikkk.handleBlur}
                                    error={formikkk.touched.Amount && Boolean(formikkk.errors.Amount)}
                                    helperText={formikkk.touched.Amount && formikkk.errors.Amount}
                                    type="number"
                                    fullWidth
                                    variant="outlined"
                                />
                                <Button
                                    size='small'
                                    onClick={() => setEnterAmt()}
                                    color='error'
                                    variant='contained'
                                    sx={{ mt:1, mr:1 }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant='contained'
                                    type='submit'
                                    color='success'
                                    size='small'
                                    sx={{ mt:1 }}
                                >
                                    {
                                        loading === true ?
                                        <Box sx={{ width: '100%' }}>
                                            <CircularProgress />
                                        </Box>
                                        : "Transfer"
                                    }
                                </Button>
                                </form>
                            </Box>
                            : enterAmt && typeAr === "loans" ?
                            <Box sx={{ mt:1 }}>
                                <form onSubmit={formikkk.handleSubmit}>
                                <TextField
                                    margin="dense"
                                    id="Amount"
                                    name="Amount"
                                    label="Amount to Transfer"
                                    onChange={(e) => formikkk.setFieldValue("Amount", e.target.value)}
                                    value={formikkk.values.Amount}
                                    onBlur={formikkk.handleBlur}
                                    error={formikkk.touched.Amount && Boolean(formikkk.errors.Amount)}
                                    helperText={formikkk.touched.Amount && formikkk.errors.Amount}
                                    type="number"
                                    fullWidth
                                    variant="outlined"
                                />
                                <Button
                                    size='small'
                                    onClick={() => setEnterAmt()}
                                    color='error'
                                    variant='contained'
                                    sx={{ mt:1, mr:1 }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant='contained'
                                    type='submit'
                                    color='success'
                                    size='small'
                                    sx={{ mt:1 }}
                                >
                                    {
                                        loading === true ?
                                        <Box sx={{ width: '100%' }}>
                                            <CircularProgress />
                                        </Box>
                                        : "Transfer"
                                    }
                                </Button>
                                </form>
                            </Box>
                            : enterAmt && typeAr === "shares" ?
                            <Box sx={{ mt:1 }}>
                                <form onSubmit={formikkk.handleSubmit}>
                                <p>1 Share = GH₵{shareValue}.00</p>
                                <TextField
                                    margin="dense"
                                    id="Amount"
                                    name="Amount"
                                    label="Amount to Transfer"
                                    onChange={(e) => formikkk.setFieldValue("Amount", e.target.value)}
                                    value={formikkk.values.Amount}
                                    onBlur={formikkk.handleBlur}
                                    error={formikkk.touched.Amount && Boolean(formikkk.errors.Amount)}
                                    helperText={formikkk.touched.Amount && formikkk.errors.Amount}
                                    type="number"
                                    fullWidth
                                    size='small'
                                    variant="outlined"
                                />

                                Share Value:
                                <Typography sx={{ fontWeight: '700' }}>GH₵{formikkk.values.Amount * shareValue}.00</Typography>

                                <FormHelperText>Set period</FormHelperText>
                            <Select
                                margin="dense"
                                disabled={(formikkk.values.period)? true :false}
                                id="period"
                                required
                                name="period"
                                onChange={formikkk.handleChange}
                                type="date"
                                value={formikkk.values.period}
                                helperText="Set Period"
                                fullWidth
                                size='small'
                                variant="outlined"
                                sx={{ marginBottom:1 }}
                            >
                                <MenuItem value={null}>Or Set number of Years</MenuItem>
                                <MenuItem value={0.25}>3 months</MenuItem>
                                <MenuItem value={0.5}>6 months</MenuItem>
                                <MenuItem value={1}>1 year</MenuItem>
                            </Select>
                            <Typography>OR</Typography>
                            <FormHelperText>Set Number of years</FormHelperText>
                            <TextField
                                margin="dense"
                                disabled={(formikkk.values.period)? true :false}
                                id="period"
                                required
                                name="period"
                                onChange={formikkk.handleChange}
                                type="number"
                                value={formikkk.values.period}
                                onBlur={formikkk.handleBlur}
                                error={formikkk.touched.period && Boolean(formikkk.errors.period)}
                                helperText={formikkk.touched.period && formikkk.errors.period}
                                // helperText="Set Number of years"
                                fullWidth
                                size='small'
                                variant="outlined"
                                sx={{ marginBottom:5 }}
                            />
                            <FormHelperText>What occurs on the date when the share ends?</FormHelperText>
                            <Select
                                required
                                margin="dense"
                                id="on_due_date"
                                name="on_due_date"
                                label="Action to be taken on due date"
                                onChange={formikkk.handleChange}
                                value={formikkk.values.on_due_date}
                                onBlur={formikkk.handleBlur}
                                error={formikkk.touched.on_due_date && Boolean(formikkk.errors.on_due_date)}
                                helperText={formikkk.touched.on_due_date && formikkk.errors.on_due_date}
                                fullWidth
                                size='small'
                                sx={{ marginBottom:1 }}
                                variant="outlined"
                            >
                                <MenuItem value="rolled over with interest">Roll Over With Interest</MenuItem>
                                <MenuItem value="rolled over without interest">Roll Over Without Interest</MenuItem>
                                <MenuItem value="canceled">End</MenuItem>
                            </Select>
                            

                            <Select
                                // margin="dense"
                                disabled={(formikkk.values.on_due_date === "rolled over with interest")? true :false}
                                id="spending_means"
                                name="spending_means"
                                label="Action to be taken on after end date"
                                onChange={formikkk.handleChange}
                                value={formikkk.values.spending_means}
                                onBlur={formikkk.handleBlur}
                                error={formikkk.touched.spending_means && Boolean(formikkk.errors.spending_means)}
                                helperText={formikkk.touched.spending_means && formikkk.errors.spending_means}
                                fullWidth
                                size='small'
                                variant="outlined"
                            >
                                <MenuItem value="transferred to your ">Transfer to Savings Account</MenuItem>
                                <MenuItem value="withdrawn">Withdraw</MenuItem>
                            </Select>


                            <Select
                                // margin="dense"
                                disabled={(formikkk.values.spending_means === "transferred to your ")? false:true }
                                id="account_name"
                                name="account_name"
                                label="Set Savings Account"
                                onChange={formikkk.handleChange}
                                value={formikkk.values.account_name}
                                helperText="Set Account"
                                fullWidth
                                sx={{ marginTop:1 }}
                                variant="outlined"
                            >
                            {savingsDetails.map((item) => (
                                <MenuItem key={item.id} value={item.account_name}>{item.account_name}</MenuItem>
                            ))} 
                            </Select>

                                <Button
                                    size='small'
                                    onClick={() => setEnterAmt()}
                                    color='error'
                                    variant='contained'
                                    sx={{ mt:1, mr:1 }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant='contained'
                                    type='submit'
                                    color='success'
                                    size='small'
                                    sx={{ mt:1 }}
                                >
                                    {
                                        loading === true ?
                                        <Box sx={{ width: '100%' }}>
                                            <CircularProgress />
                                        </Box>
                                        : "Transfer"
                                    }
                                </Button>
                                </form>
                            </Box>
                            :
                            null
                        }
                        
                        </Grid>
                        
                        </Grid>
                        
                    </Box>
                </Grid>
                </TabPanel>

            </TabContext>
                </Box> 
            </Grid>
              </Grid>
              <Button
                    onClick={handleModalCloseNow}
                    variant='contained'
                    sx={{ backgroundColor: '#ba181b', color: '#ffffff', borderRadius:2, mt:1 }}
                    size='medium'
                >
                    Close
                </Button>
              </Box>
              
            </Modal> 
            <Dialog
                open={openn}
                onClose={hangcloo}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
            <DialogTitle id="alert-dialog-title">
            {"Delete Transaction"}
            </DialogTitle>
            <DialogContent>
            <DialogContentText id="alert-dialog-description">
                This action cannot be undone. NB: this will not affect the
                current balance of the account.
                Do you wish to continue?
            </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={hangcloo}>Cancel</Button>
            <Button onClick={handleDelete} autoFocus>
                Continue
            </Button>
            </DialogActions>
        </Dialog>
        </div>
      )
}else{
    return(
        <div>
        <Box sx={{ display: 'flex' }}>
            <CircularProgress />
        </Box>

    <Dialog open={saveOpen} onClose={closeDeposit}>
    <form onSubmit={formik.handleSubmit}>
    <DialogTitle>Transaction</DialogTitle>
    <DialogContent>
    <DialogContentText>
        Deposit
    </DialogContentText>

    {stampValue 
    ?
    <>
    <p>1 Stamp = GH₵{stampValue}.00</p>
     <TextField
        margin="dense"
        id="Amount"
        name="Amount"
        label="Stamp Value"
        onChange={formik.handleChange}
        value={formik.values.Amount}
        onBlur={formik.handleBlur}
        error={formik.touched.Amount && Boolean(formik.errors.Amount)}
        helperText={formik.touched.Amount && formik.errors.Amount}
        type="number"
        fullWidth
        variant="outlined"
    />
    
    Stamp Value :
    <Typography sx={{ fontWeight: '700' }}>GH₵{formik.values.Amount * stampValue}.00</Typography>
    </>

    : 
    <TextField
        margin="dense"
        id="Amount"
        name="Amount"
        label="Amount"
        onChange={formik.handleChange}
        value={formik.values.Amount}
        onBlur={formik.handleBlur}
        error={formik.touched.Amount && Boolean(formik.errors.Amount)}
        helperText={formik.touched.Amount && formik.errors.Amount}
        type="number"
        fullWidth
        variant="outlined"
    />
    }


    <TextField
        margin="dense"
        id="narration"
        name="narration"
        label="Narration (optional)"
        onChange={formik.handleChange}
        type="text"
        value={formik.values.narration}
        onBlur={formik.handleBlur}
        error={formik.touched.narration && Boolean(formik.errors.narration)}
        helperText={formik.touched.narration && formik.errors.narration}
        fullWidth
        variant="outlined"
    />

    </DialogContent>
    <DialogActions>
    <Button onClick={closeDeposit}>Cancel</Button>
    <Button type='submit'>Deposit</Button>
    </DialogActions>
    </form>
    </Dialog>

    {/* withdraw */}
    <Dialog open={withdOpen} onClose={closeWithdraw}>
    <form onSubmit={formikk.handleSubmit}>
    <DialogTitle>Transaction</DialogTitle>
    <DialogContent>
    <DialogContentText>
        Withdraw
    </DialogContentText>
        <TextField
            margin="dense"
            id="Amountt"
            name="Amountt"
            label="Amount to withdraw"
            onChange={formikk.handleChange}
            value={formikk.values.Amountt}
            onBlur={formikk.handleBlur}
            error={formikk.touched.Amountt && Boolean(formikk.errors.Amountt)}
            helperText={formikk.touched.Amountt && formikk.errors.Amountt}
            type="number"
            fullWidth
            variant="outlined"
        />
        

    <TextField
        margin="dense"
        id="narrationn"
        name="narrationn"
        label="Narration (optional)"
        onChange={formikk.handleChange}
        type="text"
        value={formikk.values.narrationn}
        onBlur={formikk.handleBlur}
        error={formikk.touched.narrationn && Boolean(formikk.errors.narrationn)}
        helperText={formikk.touched.narrationn && formikk.errors.narrationn}
        fullWidth
        variant="outlined"
    />

    </DialogContent>
    <DialogActions>
    <Button onClick={closeWithdraw}>Cancel</Button>
    <Button type='submit'>Withdraw</Button>
    </DialogActions>
    </form>
    </Dialog>

        
    
        <Dialog
            open={openn}
            onClose={hangcloo}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
            {"Delete Transaction"}
            </DialogTitle>
            <DialogContent>
            <DialogContentText id="alert-dialog-description">
                This action cannot be undone. NB: this will also affect the
                current balance of the account.
                Do you wish to continue?
            </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={hangcloo}>Cancel</Button>
            <Button onClick={handleDelete} autoFocus>
                Continue
            </Button>
            </DialogActions>
        </Dialog>
            {/* Transfer */}
                    {/* Transfer */}
                    <Modal
                    open={modalOpen}
                    onClose={handleClosee}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                 <Box sx={style}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <Typography variant='h4' color='#023047' > Transfer  </Typography>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Box sx={{ width: '100%', typography: 'body1' }}>
                            <TabContext value={value1}>
                                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                        <TabList onChange={handleChange1} aria-label="lab API tabs example">
                                            <Tab label="My accounts" value="1" />
                                            <Tab label="Other Accounts" value="2" />
                                        </TabList>
                                    </Box>

                                    <TabPanel value="1">
                                        <TabContext value={value}>
                                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                            <TabList onChange={handleChange} aria-label="lab API tabs example">
                                                <Tab label="Savings Account" value="1" />
                                                <Tab label="Pay off Loans" value="2" />
                                                <Tab label="Buy Shares" value="3" />
                                            </TabList>
                                        </Box>
                                    <TabPanel value="1">
                                        {
                                            transferInfo.My_Savings_Acc?
                                            <>
                                                <Autocomplete
                                                    disablePortal
                                                    id="combo-box-demo"
                                                    options={transferInfo.My_Savings_Acc}
                                                    sx={{ width: 300 }}
                                                    getOptionLabel={(option) => `${option.account_name} (${option.association_name})`}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id} // Assuming 'id' is a unique identifier
                                                    onChange={(event, value) => {
                                                        if (value) {
                                                            openUpForm(value.id, "savings");
                                                        }
                                                    }}
                                                    renderInput={(params) => <TextField {...params} label="Select Savings Account" />}
                                                />
                                        </>
                                            :<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <CircularProgress />
                                            </Box>
                                        }
                                        
                                    </TabPanel>
                                    <TabPanel value="2">
                                        {
                                            transferInfo.My_Loans_Acc?
                                            <>
                                            <Autocomplete
                                                    disablePortal
                                                    id="combo-box-demo"
                                                    options={transferInfo.My_Loans_Acc}
                                                    sx={{ width: 300 }}
                                                    getOptionLabel={(option) => `${option.account_name} (${option.association_name})`}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id} // Assuming 'id' is a unique identifier
                                                    onChange={(event, value) => {
                                                        if (value) {
                                                            openUpForm(value.id, "loans");
                                                        }
                                                    }}
                                                    renderInput={(params) => <TextField {...params} label="Select Loan Account" />}
                                                />
                                            </>
                                            :<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <CircularProgress />
                                            </Box>
                                        }
                                    </TabPanel>
                                    <TabPanel value="3">
                                        {
                                            transferInfo.My_Shares_Acc?
                                            <>
                                            <Autocomplete
                                                    disablePortal
                                                    id="combo-box-demo"
                                                    options={transferInfo.My_Shares_Acc}
                                                    sx={{ width: 300 }}
                                                    getOptionLabel={(option) => `${option.account_name} (${option.association_name})`}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id} // Assuming 'id' is a unique identifier
                                                    onChange={(event, value) => {
                                                        if (value) {
                                                            openUpForm(value.id, "shares");
                                                        }
                                                    }}
                                                    renderInput={(params) => <TextField {...params} label="Select Share Account" />}
                                                />
                                            </>
                                            :<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <CircularProgress />
                                            </Box>
                                        }
                                    </TabPanel>
                                </TabContext>
                       <Grid item xs={12} md={6}>
                        {
                            enterAmt && typeAr === "savings"
                            ?
                            <Box sx={{ mt:2 }}>
                                <form onSubmit={formikkk.handleSubmit}>
                                <TextField
                                    margin="dense"
                                    id="Amount"
                                    name="Amount"
                                    label="Amount to Transfer"
                                    onChange={(e) => formikkk.setFieldValue("Amount", e.target.value)}
                                    value={formikkk.values.Amount}
                                    onBlur={formikkk.handleBlur}
                                    error={formikkk.touched.Amount && Boolean(formikkk.errors.Amount)}
                                    helperText={formikkk.touched.Amount && formikkk.errors.Amount}
                                    type="number"
                                    fullWidth
                                    variant="outlined"
                                />
                                <Button
                                    size='small'
                                    onClick={() => setEnterAmt()}
                                    color='error'
                                    variant='contained'
                                    sx={{ mt:1, mr:1 }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant='contained'
                                    type='submit'
                                    color='success'
                                    size='small'
                                    sx={{ mt:1 }}
                                >
                                    {
                                        loading === true ?
                                        <Box sx={{ width: '100%' }}>
                                            <CircularProgress />
                                        </Box>
                                        : "Transfer"
                                    }
                                </Button>
                                </form>
                            </Box>
                            : enterAmt && typeAr === "loans" ?
                            <Box sx={{ mt:2 }}>
                                <form onSubmit={formikkk.handleSubmit}>
                                <TextField
                                    margin="dense"
                                    id="Amount"
                                    name="Amount"
                                    label="Amount to Transfer"
                                    onChange={(e) => formikkk.setFieldValue("Amount", e.target.value)}
                                    value={formikkk.values.Amount}
                                    onBlur={formikkk.handleBlur}
                                    error={formikkk.touched.Amount && Boolean(formikkk.errors.Amount)}
                                    helperText={formikkk.touched.Amount && formikkk.errors.Amount}
                                    type="number"
                                    fullWidth
                                    variant="outlined"
                                />
                                <Button
                                    size='small'
                                    onClick={() => setEnterAmt()}
                                    color='error'
                                    variant='contained'
                                    sx={{ mt:1, mr:1 }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant='contained'
                                    type='submit'
                                    color='success'
                                    size='small'
                                    sx={{ mt:1 }}
                                >
                                    {
                                        loading === true ?
                                        <Box sx={{ width: '100%' }}>
                                            <CircularProgress />
                                        </Box>
                                        : "Transfer"
                                    }
                                </Button>
                                </form>
                            </Box>
                            : enterAmt && typeAr === "shares" ?
                            <Box sx={{ mt:2 }}>
                                <form onSubmit={formikkk.handleSubmit}>
                                 <TextField
                                    margin="dense"
                                    id="Amount"
                                    name="Amount"
                                    label="Amount to Transfer"
                                    onChange={(e) => formikkk.setFieldValue("Amount", e.target.value)}
                                    value={formikkk.values.Amount}
                                    onBlur={formikkk.handleBlur}
                                    error={formikkk.touched.Amount && Boolean(formikkk.errors.Amount)}
                                    helperText={formikkk.touched.Amount && formikkk.errors.Amount}
                                    type="number"
                                    fullWidth
                                    variant="outlined"
                                />
                                <Button
                                    size='small'
                                    onClick={() => setEnterAmt()}
                                    color='error'
                                    variant='contained'
                                    sx={{ mt:1, mr:1 }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant='contained'
                                    type='submit'
                                    color='success'
                                    size='small'
                                    sx={{ mt:1 }}
                                >
                                    {
                                        loading === true ?
                                        <Box sx={{ width: '100%' }}>
                                            <CircularProgress />
                                        </Box>
                                        : "Transfer"
                                    }
                                </Button>
                                </form>
                            </Box>
                            :
                            <>
                                <Typography
                                    variant='h5'
                                    sx={{color:'#023047', mt:2}}
                                >
                                    Click on an account to start transfer 
                                </Typography>
                            </>
                        }
                        
                        </Grid>
                 </TabPanel>
                                    
                <TabPanel value="2">
                <Grid item xs={12} md={12}>
                    <Box sx={{ width: '100%', typography: 'body1' }}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={6}>
                                <Typography variant='h5'> Select Society</Typography>

                                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                    {
                                        society.map((item) =>
                                        (
                                            <Chip key={item.id} onClick={() => getKinds(item.id)} label={`${item.society}`} style={{ margin: '4px'}} sx={{ backgroundColor:"#c1121f", color: '#f5ebe0' }} />
                                        ))
                                    }
                                </div>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                {   
                                    AssoKinds[0] ?
                                    (
                                        <>
                                        <Typography variant='h5'>Select Savings Group Kind</Typography>
                                            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                {AssoKinds.map((assoKind) => (
                                                    <Chip
                                                        key={assoKind.associationtype_id}
                                                        label={`${assoKind.association_type}`}
                                                        style={{ margin: '4px' }}
                                                        sx={{ backgroundColor: "#fdf0d5", color: '#000814' }}
                                                        onClick={() => handleAssocia(assoKind.associationtype_id)}
                                                    />
                                                ))}
                                            </div>
                                            <Button
                                                onClick={() => setAssoKinds([])}
                                                variant='contained'
                                                sx={{ backgroundColor: '#9a031e', color: '#f2e8cf', borderRadius:2, mt:2 }}
                                                size='small'
                                                disabled={associations_all[1]? true: false}
                                            >
                                                Close
                                            </Button>
                                        </>
                                    )
                                    : null
                                }
                            </Grid>
                            <Grid item xs={12} md={6} sx={{ mt:2 }}>
                                {
                                    associations_all[1] ?
                                    <>
                                        <Autocomplete
                                            id="combo-box-associations"
                                            options={associations_all[1]}
                                            getOptionLabel={(option) => option.association_name}
                                            sx={{ width: 300, mb: 2 }}
                                            renderInput={(params) => <TextField {...params} label="Filter Savings Groups" />}
                                            onChange={(event, value) => {
                                                if (value) {
                                                    handlePassBook(value.association_id);
                                                }
                                            }}
                                            renderOption={(props, option) => (
                                                <li {...props} key={option.association_id}>
                                                    {option.association_name}
                                                </li>
                                            )}
                                        />


                                    <Button
                                        onClick={() => setAssociations_All([])}
                                        variant='contained'
                                        sx={{ backgroundColor: '#9a031e', color: '#f2e8cf', borderRadius:2, mt:2 }}
                                        size='small'
                                        disabled={passbook_all[0]? true: false}
                                    >
                                        Close
                                    </Button>
                                    </>
                                    : null
                                }
                            </Grid>

                            <Grid item xs={12} md={6} sx={{ mt:2 }}>
                                {
                                    passbook_all[0] ?
                                    <>
                                    <Typography variant='h5'>Select Passbook</Typography>
                                    <Autocomplete
                                        id="combo-box-passbook"
                                        options={passbook_all}
                                        getOptionLabel={(option) => `${option.firstname} ${option.lastname} (${option.passbook_id})`}
                                        sx={{ width: 300, mb: 2 }}
                                        renderInput={(params) => <TextField {...params} label="Select Member" />}
                                        onChange={(event, value) => {
                                            if (value) {
                                                fetchAccounts(value.association_members_id, `${value.firstname} ${value.lastname}`);
                                            }
                                        }}
                                        renderOption={(props, option) => (
                                            <li {...props} key={option.association_members_id}>
                                                {`${option.firstname} ${option.lastname} (${option.association_members_id})`}
                                            </li>
                                        )}
                                    />

                                    <Button
                                        onClick={() => setPassbook_All([])}
                                        variant='contained'
                                        sx={{ backgroundColor: '#9a031e', color: '#f2e8cf', borderRadius:2, mt:2 }}
                                        size='small'
                                    >
                                        Close
                                    </Button>
                                    </>
                                    : null
                                }
                            </Grid>

                            <Grid item xs={12} md={12}>
                                {
                                    savingsAcc[0] || loansAcc[0] || sharesAcc[0]? 
                                    <>
                                    <Typography variant='h6' color='#023047' > Transfer to {owner_name}  </Typography>
                                        <TabContext value={value2}>
                                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                                <TabList onChange={handleChange2} aria-label="lab API tabs example">
                                                    <Tab label="Chose Tab" value="4" />
                                                    <Tab label="Savings Account" value="1" />
                                                    <Tab label="Pay off Loan" value="2" />
                                                    <Tab label="Buy Share" value="3" />
                                                </TabList>
                                            </Box>
                                                <TabPanel value='4'>

                                                </TabPanel>
                                            <TabPanel value='1'>
                                                {
                                                    savingsAcc[0]?
                                                    <>
                                                        <Autocomplete
                                                            id="combo-box-savings"
                                                            options={savingsAcc}
                                                            getOptionLabel={(option) => option.Account_Name}
                                                            sx={{ width: 300, mb: 2 }}
                                                            renderInput={(params) => <TextField {...params} label="Select Savings Account" />}
                                                            onChange={(event, value) => {
                                                                if (value) {
                                                                    openUpForm(value.ID, "savings");
                                                                }
                                                            }}
                                                            renderOption={(props, option) => (
                                                                <li {...props} key={option.ID}>
                                                                    {option.Account_Name}
                                                                </li>
                                                            )}
                                                        />

                                                    </>
                                                    :<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                        <CircularProgress />
                                                    </Box>
                                                }
                                            </TabPanel>

                                            <TabPanel value='2'>
                                            {
                                                    loansAcc[0]?
                                                    <Autocomplete
                                                        id="combo-box-savings"
                                                        options={loansAcc}
                                                        getOptionLabel={(option) => option.account_name}
                                                        sx={{ width: 300, mb: 2 }}
                                                        renderInput={(params) => <TextField {...params} label="Select Loan Account" />}
                                                        onChange={(event, value) => {
                                                            if (value) {
                                                                openUpForm(value.ID, "loans");
                                                            }
                                                        }}
                                                        renderOption={(props, option) => (
                                                            <li {...props} key={option.ID}>
                                                                {option.account_name}
                                                            </li>
                                                        )}
                                                    />
                                                
                                                    :<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                        <CircularProgress />
                                                    </Box>
                                                }
                                            </TabPanel>

                                            <TabPanel value='3'>
                                            {
                                                    sharesAcc[0]?
                                                    <Autocomplete
                                                        id="combo-box-savings"
                                                        options={sharesAcc}
                                                        getOptionLabel={(option) => option.account_name}
                                                        sx={{ width: 300, mb: 2 }}
                                                        renderInput={(params) => <TextField {...params} label="Select Share Account" />}
                                                        onChange={(event, value) => {
                                                            if (value) {
                                                                openUpForm(value.ID, "shares");
                                                            }
                                                        }}
                                                        renderOption={(props, option) => (
                                                            <li {...props} key={option.ID}>
                                                                {option.account_name}
                                                            </li>
                                                        )}
                                                    />
                                                    :<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                        <CircularProgress />
                                                    </Box>
                                                }
                                            </TabPanel>
                                        </TabContext>
                                    </>
                                    :
                                    null
                                }
                            </Grid>
                            <Grid item xs={12} md={12}>
                        {
                            enterAmt && typeAr === "savings"
                            ?
                            <Box sx={{ mt:1 }}>
                                <form onSubmit={formikkk.handleSubmit}>
                                <TextField
                                    margin="dense"
                                    id="Amount"
                                    name="Amount"
                                    label="Amount to Transfer"
                                    onChange={(e) => formikkk.setFieldValue("Amount", e.target.value)}
                                    value={formikkk.values.Amount}
                                    onBlur={formikkk.handleBlur}
                                    error={formikkk.touched.Amount && Boolean(formikkk.errors.Amount)}
                                    helperText={formikkk.touched.Amount && formikkk.errors.Amount}
                                    type="number"
                                    fullWidth
                                    variant="outlined"
                                />
                                <Button
                                    size='small'
                                    onClick={() => setEnterAmt()}
                                    color='error'
                                    variant='contained'
                                    sx={{ mt:1, mr:1 }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant='contained'
                                    type='submit'
                                    color='success'
                                    size='small'
                                    sx={{ mt:1 }}
                                >
                                    {
                                        loading === true ?
                                        <Box sx={{ width: '100%' }}>
                                            <CircularProgress />
                                        </Box>
                                        : "Transfer"
                                    }
                                </Button>
                                </form>
                            </Box>
                            : enterAmt && typeAr === "loans" ?
                            <Box sx={{ mt:1 }}>
                                <form onSubmit={formikkk.handleSubmit}>
                                <TextField
                                    margin="dense"
                                    id="Amount"
                                    name="Amount"
                                    label="Amount to Transfer"
                                    onChange={(e) => formikkk.setFieldValue("Amount", e.target.value)}
                                    value={formikkk.values.Amount}
                                    onBlur={formikkk.handleBlur}
                                    error={formikkk.touched.Amount && Boolean(formikkk.errors.Amount)}
                                    helperText={formikkk.touched.Amount && formikkk.errors.Amount}
                                    type="number"
                                    fullWidth
                                    variant="outlined"
                                />
                                <Button
                                    size='small'
                                    onClick={() => setEnterAmt()}
                                    color='error'
                                    variant='contained'
                                    sx={{ mt:1, mr:1 }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant='contained'
                                    type='submit'
                                    color='success'
                                    size='small'
                                    sx={{ mt:1 }}
                                >
                                    {
                                        loading === true ?
                                        <Box sx={{ width: '100%' }}>
                                            <CircularProgress />
                                        </Box>
                                        : "Transfer"
                                    }
                                </Button>
                                </form>
                            </Box>
                            : enterAmt && typeAr === "shares" ?
                            <Box sx={{ mt:1 }}>
                                <form onSubmit={formikkk.handleSubmit}>
                                <TextField
                                    margin="dense"
                                    id="Amount"
                                    name="Amount"
                                    label="Amount to Transfer"
                                    onChange={(e) => formikkk.setFieldValue("Amount", e.target.value)}
                                    value={formikkk.values.Amount}
                                    onBlur={formikkk.handleBlur}
                                    error={formikkk.touched.Amount && Boolean(formikkk.errors.Amount)}
                                    helperText={formikkk.touched.Amount && formikkk.errors.Amount}
                                    type="number"
                                    fullWidth
                                    variant="outlined"
                                />
                                <Button
                                    size='small'
                                    onClick={() => setEnterAmt()}
                                    color='error'
                                    variant='contained'
                                    sx={{ mt:1, mr:1 }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant='contained'
                                    type='submit'
                                    color='success'
                                    size='small'
                                    sx={{ mt:1 }}
                                >
                                    {
                                        loading === true ?
                                        <Box sx={{ width: '100%' }}>
                                            <CircularProgress />
                                        </Box>
                                        : "Transfer"
                                    }
                                </Button>
                                </form>
                            </Box>
                            :
                            <>
                                <Typography
                                    variant='h5'
                                    sx={{color:'#023047', mt:2}}
                                >
                                    Click on an account to start transfer 
                                </Typography>
                            </>
                        }
                        
                        </Grid>
                        
                        </Grid>
                        
                    </Box>
                </Grid>
                </TabPanel>

            </TabContext>
                </Box> 
            </Grid>
              </Grid>
              <Button
                    onClick={handleModalCloseNow}
                    variant='contained'
                    sx={{ backgroundColor: '#ba181b', color: '#ffffff', borderRadius:2, mt:1 }}
                    size='medium'
                >
                    Close
                </Button>
              </Box>
              
            </Modal>
    </div>
    )
}

} 

